import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const AdminRoute = () => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/admin-login" replace />;
  }

  try {
    const decoded = jwtDecode(token);

    if ((decoded.role || "").toLowerCase() !== "admin") {
      return <Navigate to="/" replace />;
    }

    return <Outlet />;
  } catch (err) {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    return <Navigate to="/admin-login" replace />;
  }
};

export default AdminRoute;